import api from '@services/api';
import {
  ExtraCollaboratorParans,
  ExtraCollaboratorRequest,
  ExtraCollaboratorResponse,
} from '../models/extraCollaborator';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all sharing related CRUD calls
 */

export const extraCollaboratorApi = api.injectEndpoints({
  endpoints: (builder) => ({
    ListAllCollaborator: builder.query<PaginationResponse<ExtraCollaboratorResponse>, ExtraCollaboratorParans>({
      query: (params: ExtraCollaboratorParans) => {
        const searchTerm = params.searchTerm ?? '';
        return {
          url: encodeURI(
            `/indirect/late-sharing-config/searchBy?searchTerm=${searchTerm}&page=${params.page}&size=${params.size}`,
          ),
          method: 'GET',
        };
      },
      providesTags: ['ListAllCollaborator'],
    }),
    createCollaboratorExtra: builder.mutation<void, ExtraCollaboratorRequest>({
      query: (input) => ({
        url: '/indirect/late-sharing-config/create',
        method: 'POST',
        body: input,
      }),
      invalidatesTags: ['ListAllCollaborator'],
    }),
    removeCollaboratorExtra: builder.mutation<void, number>({
      query: (id) => ({
        url: `/indirect/late-sharing-config/delete?id=${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ListAllCollaborator'],
    }),
  }),
});

export const { useListAllCollaboratorQuery, useCreateCollaboratorExtraMutation, useRemoveCollaboratorExtraMutation } =
  extraCollaboratorApi;
